import { CheckCircle2, FileText } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { CtaButton } from "./CtaButton";

const ITEMS = [
  {
    title: "Checklist przygotowania do kontroli Sanepidu + PIP",
    sub: "Połączone w jeden dokument — nie osobno. Przechodzisz punkt po punkcie.",
  },
  {
    title: "Regulamin rezerwacji z klauzulą o no-show",
    sub: "Masz podstawę, by dochodzić straty za puste stoliki.",
  },
  {
    title: "Wzór umowy o pracę / zlecenie",
    sub: "Dostosowany do gastronomii — zmianowość, sezonowość, praca w weekendy.",
  },
  {
    title: "Klauzula RODO do monitoringu wizyjnego",
    sub: "Legalne kamery w lokalu — z informacją dla gości i pracowników.",
  },
];

export const PackageSection = ({ onBuy }) => (
  <section id="pakiet" data-testid="package-section" className="bg-white px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
    <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
      <Reveal>
        <Kicker index="02" label="Zawartość" />
        <h2 className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Co dostajesz w pakiecie
        </h2>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-clay sm:text-base">
          Cztery dokumenty, które zamykają najczęstsze powody kar w
          gastronomii. Bez prawniczego żargonu — każdy plik ma oznaczone
          miejsca do uzupełnienia danymi Twojego lokalu.
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-3">
          {["DOC", "PDF"].map((f) => (
            <span
              key={f}
              data-testid={`format-chip-${f.toLowerCase()}`}
              className="inline-flex items-center gap-2 rounded-full border border-sand bg-cream px-4 py-2 text-xs font-semibold uppercase tracking-wider text-choc"
            >
              <FileText className="h-4 w-4 text-brick" />
              {f}
            </span>
          ))}
          <span className="text-xs text-clay">Edytowalne od razu po zakupie</span>
        </div>
      </Reveal>

      <div>
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={0.07 * i}>
            <div
              data-testid={`package-item-${i}`}
              className="group flex gap-5 border-b border-sand py-7 transition-colors duration-300 first:pt-0 hover:border-brick/40 sm:gap-7 sm:py-8"
            >
              <CheckCircle2 className="mt-1 h-7 w-7 shrink-0 text-brick transition-transform duration-300 group-hover:scale-110" />
              <div>
                <h3 className="font-display text-lg font-semibold leading-snug sm:text-xl">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-clay">{item.sub}</p>
              </div>
            </div>
          </Reveal>
        ))}
        <Reveal className="mt-10 flex justify-center lg:justify-start">
          <CtaButton onBuy={onBuy} testid="package-cta-button" />
        </Reveal>
      </div>
    </div>
  </section>
);
